import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconZoomIn: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 192.904 192.904" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="m190.707 180.101-47.078-47.077c11.702-14.072 18.752-32.142 18.752-51.831 0-44.77-36.422-81.193-81.19-81.193-44.769 0-81.191 36.423-81.191 81.193 0 44.767 36.422 81.187 81.191 81.187 19.688 0 37.759-7.049 51.831-18.751l47.079 47.078c1.464 1.465 3.384 2.197 5.303 2.197s3.839-.732 5.304-2.197c2.929-2.929 2.929-7.677-.001-10.606zm-175.707-98.908c0-36.499 29.693-66.193 66.191-66.193 36.497 0 66.189 29.694 66.189 66.193 0 36.496-29.692 66.187-66.189 66.187-36.498 0-66.191-29.691-66.191-66.187z" />
      <path d="m118.035 73.689h-29.345v-29.344c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v29.345h-29.344c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h29.344v29.346c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-29.347h29.345c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5z" />
    </svg>
  </IconStyled>
);

IconZoomIn.defaultProps = iconDefaultProps;
IconZoomIn.displayName = 'IconZoomIn';

export default IconZoomIn;
